import React from "react";
import { useTranslation } from "react-i18next";
import { AppLayout } from "../../Layouts";
import PageLayout from "../../Layouts/PageLayout";
import SettingsContentLayout from "../../Layouts/SettingsContentLayout";
import ActivityHistoryContent from "../../Components/Features/Settings/ActivityHistoryContent";

function ActivityHistoryPage() {
  const { t } = useTranslation();

  return (
    <AppLayout>
      <PageLayout title={t("activity-history")}>
        <div className="h-fit md:h-screen w-full bg-white rounded-xl shadow-accent-foreground shadow-2xl ">
          <SettingsContentLayout>
            <ActivityHistoryContent />
          </SettingsContentLayout>
        </div>
      </PageLayout>
    </AppLayout>
  );
}

export default ActivityHistoryPage;
